import { PlainTextTemplateItem } from './MagicFormPlainTextViewer';
import { PlainTextItemConditionRule } from '../../Enums/PlainTextItemConditionRule.enum';

export const PlainTextViewerTemplates: Record<string, PlainTextTemplateItem[]> =
	{
		kdarAmbulantWizardDoctor: [
			{
				text: 'Druh a temín výkonu: ',
				children: [
					{
						text: '{{kdarPerformanceType}}',
					},
					{
						text: '{{kdarPerformanceSide}}',
						conditions: [
							{
								key: 'kdarPerformanceSide',
								value: 'none',
								rule: PlainTextItemConditionRule.NOT_EQUAL,
							},
						],
					},
					{
						text: '{{kdarOperationDate}}',
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: '\n',
			},
			{
				text: 'Souhlas s regionální anestezií: {{kdarAnesthesiaType}}',
			},
			{
				text: '\n',
			},
			{
				text: 'Váha pacienta: {{kdarChildWeight}} kg',
			},
			{
				text: '\n',
			},
			{
				text: '\n',
			},
			{
				text: 'RA: ',
				children: [
					{
						text: 'nevýznamná',
						conditions: [
							{
								key: 'kdarFamilyHeart',
								value: '0',
							},
							{
								key: 'kdarFamilyMuscle',
								value: '0',
							},
							{
								key: 'kdarFamilyBlood',
								value: '0',
							},
							{
								key: 'kdarFamilyAnesthesia',
								value: '0',
							},
						],
					},
					{
						text: 'Srdeční onemocnění: {{kdarFamilyHeartItem}}',
						conditions: [
							{
								key: 'kdarFamilyHeart',
								value: '1',
							},
						],
					},
					{
						text: 'Svalové onemocnění: {{kdarFamilyMuscleItem}}',
						conditions: [
							{
								key: 'kdarFamilyMuscle',
								value: '1',
							},
						],
					},
					{
						text: 'Poruchy srážlivosti krve: {{kdarFamilyBloodItem}}',
						conditions: [
							{
								key: 'kdarFamilyBlood',
								value: '1',
							},
						],
					},
					{
						text: 'Potíže v celkové anestezii:',
						conditions: [
							{
								key: 'kdarFamilyAnesthesia',
								value: '1',
							},
						],
						children: [
							{
								text: '{{kdarFamilyAnesthesiaItem0}}',
								conditions: [
									{
										key: 'kdarFamilyAnesthesiaItem0',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarFamilyAnesthesiaItem1}}',
								conditions: [
									{
										key: 'kdarFamilyAnesthesiaItem1',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarFamilyAnesthesiaItem2}}',
								conditions: [
									{
										key: 'kdarFamilyAnesthesiaItem2',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarFamilyAnesthesiaItem3}}',
							},
						],
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'OA: ',
				children: [
					{
						text: 'zdravý/-á ',
						conditions: [
							{
								key: 'kdarBirth',
								value: '0',
							},
							{
								key: 'kdarTransfusion',
								value: '0',
							},
							{
								key: 'kdarFever',
								value: '0',
							},
							{
								key: 'kdarAmbulance',
								value: '0',
							},
						],
					},
					{
						text: 'Předčasné narození: {{kdarBirthItemWeight}} g, {{kdarBirthItemWeek}}',
						conditions: [
							{
								key: 'kdarBirth',
								value: '1',
							},
						],
					},
					{
						text: 'Krevní transfúze: {{kdarTransfusionItem}}',
						conditions: [
							{
								key: 'kdarTransfusion',
								value: '1',
							},
						],
					},
					{
						text: 'Křeče při horečkách {{kdarFeverItem}}',
						conditions: [
							{
								key: 'kdarFever',
								value: '1',
							},
						],
					},
					{
						text: '',
						conditions: [
							{
								key: 'kdarAmbulance',
								value: '1',
							},
						],
						children: [
							{
								text: '{{kdarAmbulanceItem0}} - {{kdarAmbulanceItem0Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem0',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem1}} - {{kdarAmbulanceItem1Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem1',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem2}} - {{kdarAmbulanceItem2Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem2',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem3}} - {{kdarAmbulanceItem3Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem3',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem4}} - {{kdarAmbulanceItem4Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem4',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem5}} - {{kdarAmbulanceItem5Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem5',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem6}} - {{kdarAmbulanceItem6Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem6',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem7}} - {{kdarAmbulanceItem7Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem7',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem8}} - {{kdarAmbulanceItem8Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem8',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem9}} - {{kdarAmbulanceItem9Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem9',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem10}} - {{kdarAmbulanceItem10Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem10',
										value: '1',
									},
								],
							},
							{
								text: '{{kdarAmbulanceItem11}} - {{kdarAmbulanceItem11Desc}}',
								conditions: [
									{
										key: 'kdarAmbulanceItem11',
										value: '1',
									},
								],
							},
						],
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'AA: ',
				children: [
					{
						text: 'neguje',
						conditions: [
							{
								key: 'kdarAllergy',
								value: '0',
							},
						],
					},
					{
						text: 'Potravinové alergie: {{kdarAllergyItemFood}}',
						conditions: [
							{
								key: 'kdarAllergyItemFood',
								rule: PlainTextItemConditionRule.FILLED,
							},
						],
					},
					{
						text: 'Lékové alergie: {{kdarAllergyItemMed}}',
						conditions: [
							{
								key: 'kdarAllergyItemMed',
								rule: PlainTextItemConditionRule.FILLED,
							},
						],
					},
					{
						text: 'Alergie na desinfekci: {{kdarAllergyItemDes}}',
						conditions: [
							{
								key: 'kdarAllergyItemDes',
								rule: PlainTextItemConditionRule.FILLED,
							},
						],
					},
					{
						text: 'Alergie na náplast: {{kdarAllergyItemPatch}}',
						conditions: [
							{
								key: 'kdarAllergyItemPatch',
								rule: PlainTextItemConditionRule.FILLED,
							},
						],
					},
					{
						text: 'Jiné: {{kdarAllergyItemOther}}',
						conditions: [
							{
								key: 'kdarAllergyItemOther',
								rule: PlainTextItemConditionRule.FILLED,
							},
						],
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'FA: ',
				children: [
					{
						text: 'neguje',
						conditions: [
							{
								key: 'kdarMedication',
								value: '0',
							},
						],
					},
					{
						text: '{{kdarMedicationItem}}',
						conditions: [
							{
								key: 'kdarMedicationItem',
								rule: PlainTextItemConditionRule.FILLED,
							},
						],
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: '\n',
			},
			{
				text: 'Předchozí CA a případné komplikace: ',
				children: [
					{
						text: 'Celková anestezie nebyla',
						conditions: [
							{
								key: 'kdarAnesthesia',
								value: '0',
							},
						],
					},
					{
						text: '{{kdarAnesthesiaItem}}',
						conditions: [
							{
								key: 'kdarAnesthesia',
								value: '1',
							},
						],
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'Interní předoperační vyšetření: {{kdarPreoperative}}',
			},
			{
				text: '\n',
			},
			{
				text: '                                            odběry: {{kdarSample}}',
			},
			{
				text: '\n',
			},
			{
				text: '\n',
			},
			{
				text: 'ASA: {{kdarASA}}',
				conditions: [
					{
						rule: PlainTextItemConditionRule.FILLED,
						key: 'kdarASA',
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'Mallampatti: {{kdarMallampati}}',
				conditions: [
					{
						rule: PlainTextItemConditionRule.FILLED,
						key: 'kdarMallampati',
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'Premedikace:',
			},
			{
				text: '\n',
			},
			{
				text: '\n',
			},
			{
				text: 'na noc:',
			},
			{
				text: '\n',
			},
			{
				text: '{{kdarPreMedicationNight}}',
				conditions: [
					{
						key: 'kdarPreMedicationNight',
						rule: PlainTextItemConditionRule.FILLED,
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'ráno {{kdarPreMedicationMorning}}',
				conditions: [
					{
						key: 'kdarPreMedicationMorning',
						rule: PlainTextItemConditionRule.FILLED,
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: 'na zavolání {{kdarPreMedicationCall}}',
				conditions: [
					{
						key: 'kdarPreMedicationCall',
						rule: PlainTextItemConditionRule.FILLED,
					},
				],
			},
			{
				text: '\n',
			},
			{
				text: '\n',
			},
			{
				text: '{{kdarInstruction}}',
				conditions: [
					{
						key: 'kdarInstruction',
						rule: PlainTextItemConditionRule.FILLED,
					},
				],
			},
			{
				text: 'Dozor/dohled: {{kdarSupervisor}}',
				conditions: [
					{
						key: 'kdarSupervisor',
						rule: PlainTextItemConditionRule.FILLED,
					},
				],
			},
		],
	};
